import { SocialItem } from 'sections/Blog/types';

export const socialItemsData: SocialItem[] = [
  {
    icon: 'instagram.svg',
    link: 'https://www.instagram.com/searatesllc/'
  },
  {
    icon: 'facebook.svg',
    link: 'https://www.facebook.com/searates/'
  },
  {
    icon: 'telegram.svg',
    link: 'https://t.me/searatesfeed'
  },
  {
    icon: 'youtube.svg',
    link: 'https://www.youtube.com/channel/UC-riN9Wesr6jbxi1DUTjFJQ'
  },
];